module.exports = __webpack_public_path__ + "img/w3_mc_black.0e7369f0.png";